import dateFormat from "dateformat";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import AbstractFlexibilityScreenMediator from "./AbstractFlexibilityScreenMediator";

export default class EndScreenMediator extends AbstractFlexibilityScreenMediator {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel);
    }

    initialize() {
        super.initialize();

        const elapsed = this._gameModel.elapsedTime;
        const timeStr = dateFormat(new Date(elapsed), "MM:ss.L");

        this._target.textPanel.titleTextfield.text = this.getText("endOverlay.title");
        this._target.textPanel.timeTextfield.text = this.getText("endOverlay.time", { time: timeStr });
        this._target.textPanel.bodyTextfield.text = this.getText("endOverlay.body");

        this._button = this.createButton(this._target.textPanel.button, this._handleButtonClick.bind(this), this.getText("endOverlay.button"));

        this.anchorObject(this._target.textPanel.titleTextfield, Anchor.T);
        this.anchorObject(this._target.textPanel.bodyTextfield, Anchor.T);
        this.anchorObject(this._target.textPanel.timeTextfield, Anchor.T);

        this._exposeEndButton();
    }

    _handleButtonClick(e) {
        this._button.setEnabled(false);
        this.dispatch(GameEvent.EXIT);
    }

    // Used for integration testing by Equalture
    _exposeEndButton() {
        window.actions = window.actions || {};
        window.actions.clickEndButton = () => {
            return new Promise((resolve, reject) => {
                this._handleButtonClick();
                resolve();
            });
        }
    }
};
